import { AccountState } from '../models';
export const isFulfilledAccount = (state) => state &&
    [
        AccountState.Active,
        AccountState.Suspended,
        AccountState.Closed,
        AccountState.ClosingInProgress,
    ].includes(state);
//# sourceMappingURL=transaction-account.js.map